import { useParams } from "react-router-dom";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import { Chip } from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import GuicheTableActions from "./components/table-action";
import SearchField from "../../../../../components/search-field";
import { useAttendanceLocalGuicheList } from "../../../../../../../services/api-tansquery/attendance-local/guiche/list";
import { useAttendanceLocalStyles } from "../../../../../styles";
import { useGuicheListTabPanelStyles } from "./styles";
import GuicheFormCreate from "../form/create";
import EmptyState from "../../../../../../../Components/EmptyState";
import CustomPagination from "../../../../../../../Components/pagination";

export default function GuicheListTabPanel() {
    const { slug } = useParams<{ slug: string }>();
    const { classes } = useGuicheListTabPanelStyles();
    const { classes: defaultClasses } = useAttendanceLocalStyles();
    const { data: guiches } = useAttendanceLocalGuicheList({
        unidade_slug: slug,
    });

    const isEmptyGuiches = (guiches?.results ?? []).length === 0;

    return (
        <Paper elevation={3}>
            <Box className={classes.header}>
                <Box className={classes.search}>
                    <SearchField
                    placeholder="Buscar guichê de recepção pelo responsável"
                    inputStyle={{ minWidth: 420 }}
                />
                </Box>
                <GuicheFormCreate slug={slug} />
            </Box>
            <TableContainer className={defaultClasses.tableContainer}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            <TableCell className={defaultClasses.tableTH}>Ordem</TableCell>
                            <TableCell className={defaultClasses.tableTH}>
                                Responsáveis
                            </TableCell>
                            <TableCell className={defaultClasses.tableTH}>
                                Tipo de Atendimento
                            </TableCell>
                            <TableCell className={defaultClasses.tableTH}>Ativo</TableCell>
                            <TableCell className={defaultClasses.tableTH} />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {guiches?.results.map((guiche) => (
                            <TableRow
                                hover
                                key={`guiche-${guiche.id}`}
                                role="checkbox"
                                tabIndex={-1}
                            >
                                <TableCell className={defaultClasses.tableCell}>
                                    {guiche.ordem}
                                </TableCell>
                                <TableCell className={defaultClasses.tableCell}>
                                    <Box className={classes.chipsBox}>
                                        {guiche.user.map((user) => (
                                            <Chip
                                                key={`responsable-${user.id}`}
                                                label={user.first_name}
                                            />
                                        ))}
                                    </Box>
                                </TableCell>
                                <TableCell className={defaultClasses.tableCell}>
                                    {guiche.tipo}
                                </TableCell>
                                <TableCell className={defaultClasses.tableCell}>
                                    <Box
                                        className={`${defaultClasses.badge} ${guiche.ativo
                                            ? defaultClasses.active
                                            : defaultClasses.inactive
                                            }`}
                                    >
                                        {guiche.ativo ? "Sim" : "Não"}
                                    </Box>
                                </TableCell>
                                <TableCell align="right" className={defaultClasses.tableCell}>
                                    <GuicheTableActions guiche={guiche} />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                {isEmptyGuiches && <EmptyState message="Nenhum guichê encontrado." />}
            </TableContainer>
            <Box className={defaultClasses.paginationContainer}>
                <CustomPagination
                    count={guiches?.count}
                    page={guiches?.current}
                    totalPages={guiches?.total_pages}
                />
            </Box>
        </Paper>
    );
}
